/**
 * @module events/types/mouseUp
 */

/**
 * @type {string}
 */
export default 'mouseup'
